var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcArrowRightActive = function SvgIcArrowRightActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.038 5.963-1.576 1.575 9.316 9.337H4.5v2.25h24.277l-9.315 9.337 1.576 1.576L33.098 18 21.037 5.963z",
    fill: "#000"
  })));
};
export { SvgIcArrowRightActive as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Im0yMS4wMzggNS45NjMtMS41NzYgMS41NzUgOS4zMTYgOS4zMzdINC41djIuMjVoMjQuMjc3bC05LjMxNSA5LjMzNyAxLjU3NiAxLjU3NkwzMy4wOTggMTggMjEuMDM3IDUuOTYzeiIgZmlsbD0iIzAwMCIvPgo8L3N2Zz4K";